/** Row click on an approved visit: the capture its current decision saved, with removal only on the current membership. */
import { Injector, runInInjectionContext } from '@angular/core';
import { VisitApprovalVisitRow } from '@jms/model';
import { injectDialog } from '@workbuddy/ui/v2/blocks/dialog';
import { ApprovalVisitsBoardParams } from '../visit.approval.detail.model';
import { removeFromApproval } from './approval.remove.visits.command';
import { viewCurrentApprovalVisit } from './approval.view.current.command';

export async function openApprovalSnapshot(injector: Injector, params: ApprovalVisitsBoardParams, row: VisitApprovalVisitRow): Promise<void> {

  // A later revision replaced this decision's capture, and only the current one is kept.
  if (!row.membership) return;
  const { ApprovalSnapshotComponent } = await import('../dialog/snapshot/approval.snapshot.component');
  await runInInjectionContext(injector, injectDialog).modal(ApprovalSnapshotComponent, {
    width: 'min(1000px, calc(100vw - 40px))',
    height: 'min(760px, calc(100vh - 40px))',
    inputs: {
      row: { ...row, membership: row.membership },
      approval: params.approval,
      hostReadonly: params.hostReadonly,
      viewCurrent: () => viewCurrentApprovalVisit(injector, row),
      remove: params.canRemove ? () => removeFromApproval(injector, params, [row]) : undefined,
    },
    aria: { label: 'Approved visit snapshot' },
  });
}
